import React from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

function LinkButton({ to, label = "View", primary = false }) {
    let variant = "contained";
    let color = "neutral";
    let textColor = "rgba(0,0,0,0.7)";
    let endIcon = <KeyboardArrowRightOutlinedIcon />;

    if (primary) {
        label = "Continue";
        color = "primary";
        textColor = "#FFF";
        endIcon = <KeyboardArrowRightOutlinedIcon style={{ color: "#FFF" }} />;
    }

    return (
        <Button
            variant={variant}
            color={color}
            disableElevation={true}
            aria-label={label}
            component={Link}
            to={to}
            endIcon={endIcon}
        >
            <Typography variant={"span"} sx={{ color: textColor }}>
                {label}
            </Typography>
        </Button>
    );
}

export default LinkButton;
